

















import { computed } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  props: ["item"],
});
